import React from 'react';

const CleanroomRequirements = () => {
  return (
    <div style={{ backgroundColor: '#E3F2FD', padding: '40px 20px' }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', color: '#1E88E5', fontSize: '24px', marginBottom: '30px' }}>
          Cleanroom Requirements for Medical Devices
        </h2>

        {/* Flexbox layout for image on the left and content on the right */}
        <div
          className="flex-container"
          style={{
            display: 'flex',
            flexDirection: 'row', // Default to row for larger screens
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '30px',
            flexWrap: 'wrap', // Wrap items for mobile screens
          }}
        >
          {/* Right-side Image */}
          <div
            className="image-container"
            style={{
              flex: 1,
              // maxWidth: '45%', 
              marginTop: '20px',
              display: 'block',
              marginBottom: '20px',
              textAlign: 'center',
              maxHeight: '400px',
              overflow: 'hidden',
            }}
          >
            <img
              src="/images/cleanroom.jpg" // Replace with actual image URL or path
              alt="Cleanroom for Medical Devices"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            />
          </div>

          {/* Left-side Content (Text) */}
          <div
            className="text-container"
            style={{
              flex: 1,
              marginLeft: '20px',
              marginBottom: '20px',
              maxWidth: '100%', // Ensures it does not overflow on small screens
            }}
          >
            <p style={{ fontSize: '18px', textAlign: 'justify', marginBottom: '30px' }}>
              Medical device manufacturers rely heavily on cleanrooms to ensure their products are safe for use. Cleanrooms play a crucial role in preventing contamination and maintaining hygiene during the manufacturing process. Given the nature of these products, which are often directly involved in patient care, it’s vital that they are manufactured in an environment free of harmful contaminants. Let’s explore why cleanrooms are essential for medical device manufacturing and what specific requirements are necessary for a cleanroom to be considered safe and effective.
            </p>

            <h3 style={{ color: '#1E88E5', fontSize: '20px' }}>Why Medical Devices Require Cleanrooms</h3>
            <p style={{ fontSize: '16px', textAlign: 'justify', marginBottom: '30px' }}>
              Medical devices are critical tools used in healthcare to diagnose, monitor, and treat patients. From simple tools like syringes to complex devices like prosthetic hips, the integrity and safety of these products are paramount. Contamination in the manufacturing process could lead to the introduction of dangerous bacteria or other harmful particles into the device. This could pose serious health risks to patients, especially when implants like prosthetics or medical sensors are involved, which are directly inserted into the body.
            </p>
            <p style={{ fontSize: '16px', textAlign: 'justify', marginBottom: '30px' }}>
              A <strong>cleanroom</strong> is a controlled environment designed to minimize the presence of airborne particles, bacteria, and other contaminants during the production of medical devices. The air in a cleanroom is carefully filtered, and strict procedures are followed to maintain its cleanliness. By minimizing contamination risk during production, cleanrooms ensure that medical devices are safe for use in sensitive medical procedures.
            </p>

            <h3 style={{ color: '#1E88E5', fontSize: '20px' }}>Key Cleanroom Requirements for Medical Device Manufacturing</h3>
            <ul style={{ fontSize: '16px', listStyleType: 'disc', marginBottom: '30px' }}>
              <li><strong>Air Quality Control:</strong> Cleanrooms maintain strict air quality control using high-efficiency particulate air (HEPA) filters to remove dust, bacteria, and other airborne contaminants. The air is circulated to ensure that particles are kept at a minimum, which is crucial for preventing contamination during the manufacturing process.</li>
              <li><strong>Controlled Temperature and Humidity:</strong> The temperature and humidity levels within the cleanroom must be controlled and consistent. Extreme fluctuations can cause contamination or damage to sensitive materials, affecting the integrity of the medical device.</li>
              <li><strong>Personnel Hygiene and Protection:</strong> Personnel working in cleanrooms are required to adhere to strict hygiene standards. They must wear specialized garments, such as gowns, gloves, masks, and shoe covers, to prevent contamination from body oils, hair, and other sources.</li>
            </ul>

            <p style={{ fontSize: '16px', textAlign: 'justify' }}>
              The combination of these requirements creates a clean environment where medical devices can be produced without introducing harmful contaminants that could potentially affect their safety and performance.
            </p>
          </div>
        </div>
      </div>

      {/* Mobile-specific styles */}
      <style jsx>
        {`
          @media screen and (max-width: 768px) {
            .container {
              padding: 0 15px; /* Padding adjustment for mobile */
            }
            h2 {
              font-size: 22px; /* Adjust title size for smaller screens */
            }
            p, li {
              font-size: 14px; /* Adjust paragraph and list item font size */
            }

            /* Mobile Layout - Image on top of text */
            .flex-container {
              flex-direction: column !important; /* Force column layout on small screens */
              align-items: center; /* Center content on small screens */
            }

            .image-container {
              max-width: 100%; /* Ensure image takes full width on mobile */
              margin-top: 20px;
              margin-bottom: 20px;
            }

            .text-container {
              margin-left: 0; /* Remove margin from text container */
            }

            .container img {
              max-width: 100%;
              height: auto;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CleanroomRequirements;
